import _ from 'lodash';

class AddPermissionsModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    'ngInject';

    const role = $uibModalInstance.role;
    const availablePermissions = $uibModalInstance.availablePermissions || [];

    $scope.selectedPermissions = [];
    $scope.permissionFilter = '';
    $scope.errorMessage = '';
    $scope.saving = false;
    $scope.allAvailablePermissionsTableData = availablePermissions.map(function (permission) {
      return {
        id: permission.id,
        name: permission.name,
        displayName: permission.displayName || permission.name,
        description: permission.description,
        _permission: permission
      };
    });
    $scope.availablePermissionsTableData = $scope.allAvailablePermissionsTableData.slice();

    $scope.refreshFilteredPermissions = function () {
      const filter = ($scope.permissionFilter || '').toLowerCase();
      if (!filter) {
        $scope.availablePermissionsTableData = $scope.allAvailablePermissionsTableData.slice();
        return;
      }
      $scope.availablePermissionsTableData = $scope.allAvailablePermissionsTableData.filter(function (record) {
        return (record.displayName && record.displayName.toLowerCase().indexOf(filter) !== -1) ||
          (record.name && record.name.toLowerCase().indexOf(filter) !== -1) ||
          (record.description && record.description.toLowerCase().indexOf(filter) !== -1);
      });
    };

    $scope.$watch('permissionFilter', function () {
      $scope.refreshFilteredPermissions();
    });

    $scope.permissionColumns = [
      {
        displayName: 'Permission',
        value: 'displayName',
        sortable: true,
        formatting: function (record) {
          return record.displayName || record.name || '';
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        formatting: function (record) {
          return record.description || '—';
        }
      }
    ];

    $scope.selectPermission = function (record, selected) {
      if (selected) {
        const alreadySelected = $scope.selectedPermissions.some(function (row) {
          return row.id === record.id;
        });
        if (!alreadySelected) {
          $scope.selectedPermissions.push(record._permission);
        }
      } else {
        _.remove($scope.selectedPermissions, function (row) {
          return row.id === record.id;
        });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };

    $scope.addPermissions = function () {
      if (!$scope.selectedPermissions.length || $scope.saving) {
        return;
      }

      $scope.saving = true;
      $scope.errorMessage = '';

      $http.post(
        $rootScope.apiHost + '/api/admin/roles/' + role.id + '/permissions/batch',
        {
          permissionIds: $scope.selectedPermissions.map(function (permission) {
            return permission.id;
          })
        },
        { withCredentials: true }
      ).then(function (success) {
        $uibModalInstance.close(success.data);
      }, function (failure) {
        $scope.saving = false;
        $scope.errorMessage = (failure.data && failure.data.message)
          ? failure.data.message
          : 'Could not add one or more permissions.';
      });
    };
  }
}

export default AddPermissionsModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/modals/addPermissionsModal/addPermissionsModal.controller.js